export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9303.bbc5c098.jpg";